import React, { useState, useEffect } from 'react';

import { trackEvent } from 'utils/metricsTracking';
import { EVENTS } from 'consts/metricsTrackingEvents';

import {
  AccordionToggle,
  AnswerContainer,
  QuestionContainer,
  wrapQuestionStyles,
} from './FaqAccordion.style';
import type { FaqType } from '..';

interface FaqAccordionProps {
  faq: FaqType;
  themeType: string;
}

export const FaqAccordion = ({ faq, themeType }: FaqAccordionProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const { answer, question, richTextQuestion } = faq;

  useEffect(() => {
    if (isOpen) {
      trackEvent(EVENTS.moduleInteraction, {
        'Element Content': question,
        'Module Name': `FAQ`,
        'Module Element Section': 'Questions',
        'Module Element Interaction Type': 'Click',
        path: window.location.pathname,
      });
    }
  }, [isOpen]);

  const formattedQuestion = richTextQuestion ? (
    <span css={wrapQuestionStyles}>{richTextQuestion}</span>
  ) : (
    <span
      css={wrapQuestionStyles}
      dangerouslySetInnerHTML={{ __html: question }}
    />
  );

  return (
    <div>
      <QuestionContainer onClick={() => setIsOpen(!isOpen)}>
        {formattedQuestion}
        <AccordionToggle isOpen={isOpen} />
      </QuestionContainer>
      <AnswerContainer isOpen={isOpen} themeType={themeType}>
        {answer}
      </AnswerContainer>
    </div>
  );
};
